import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';
import { loadChat } from 'app/rest/effects/chats/chat/loadChat';

//TODO done
/***
 * с бека приходять ИД чатов в которых произошли изменения, загружаем и кладем в стор
 * @param response
 */
export const updateChatsFromResponse = (
    response: any
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (!response || !response.headers || !response.headers.get('chats')) return;

        const chats: [] = JSON.parse(response.headers.get('chats'));
        chats.forEach((id) =>{
            return dispatch(loadChat(id, true));
        })

    };
    return action;
};
